export default "__VITE_ASSET__CJJP2i3X__"